import { showTime, showDate, getTimeOfDay } from "./modules/Time";
import { showGreeting } from "./modules/Greetings";
import { setLocalStorage, getLocalStorage } from "./modules/GetSetStorage";
import {
  getRandomNum,
  getSlideNext,
  getSlidePrev,
  setBg,
} from "./modules/Slider";
import { getWeather, setCity } from "./modules/Weather";
import { playAudio } from "./modules/Player";
import {
  translateEnRu,
  greetingTranslate,
  dictionaryEn,
  dictionaryRu,
} from "./modules/Translate";
import { getQuotes } from "./modules/Quotes";
import playlist from "./modules/PlayList.js";

const translate = document.querySelector(".translate");
const changeQuotes = document.querySelector(".change-quote");
let langCurrent;
window.onload = function () {
  showTime();
  showDate();
  showGreeting();
  getTimeOfDay();
  setBg();
  getWeather();
  translateEnRu();
  changeQuotes.addEventListener("click", (e) => {
    getQuotes(langCurrent);
  });
};
window.addEventListener("beforeunload", () => {
  localStorage.setItem("city", city.value);
});

//Player
const player = document.querySelector(".play");
const playPrev = document.querySelector(".play-prev");
const playNext = document.querySelector(".play-next");
const audio = document.querySelector(".audio");
let isPlay = false;
let playNum = 0;
player.addEventListener("click", () => {
  playAudio();
});
playPrev.addEventListener("click", () => {
  if (playNum > playlist.length) audio.src = playAudio(); // playlist[playNum ].src;
});
playNext.addEventListener("click", () => {
  audio.src = playlist[playNum + 1].src;
  playAudio();
});
/*----------------ToDo----------------------------------------*/
let addMessage = document.querySelector(".message");
let addButton = document.querySelector(".add");
let todo = document.querySelector(".todo");

let toDoList = [];
if (localStorage.getItem("todo")) {
  toDoList = JSON.parse(localStorage.getItem("todo"));
  displayMessages();
}
addButton.addEventListener("click", function () {
  if (!addMessage.value) return;
  let newToDo = {
    todo: addMessage.value,
    checked: false,
    important: false,
  };
  toDoList.push(newToDo);
  displayMessages();
  localStorage.setItem("todo", JSON.stringify(toDoList));
  addMessage.value = "";
});

function displayMessages() {
  let displayMessage = "";
  if (toDoList.length == 0) {
    todo.innerHTML = "";
  }
  toDoList.forEach(function (item, i) {
    displayMessage += `
  <li>
  <input type ="checkbox" id = "item-${i}" ${item.checked ? "checked" : ""}>
  <label for="item-${i}" class="${item.important ? "important" : ""}>${
      item.todo
    }</label>
    </li>
 `;
    todo.innerHTML = displayMessage;
  });
}
todo.addEventListener("change", function (e) {
  let idInput = e.target.getAttribute("id");
  let forLabel = todo.querySelector("[for=" + idInput + "]");
  let valueLabel = forLabel.innerHTML;
  toDoList.forEach(function (item, i) {
    if (item.todo == valueLabel) {
      item.checked != item.checked;
      localStorage.setItem("todo", JSON.stringify(toDoList));
    }
  });
});
todo.addEventListener("contextmenu", function (event) {
  event.preventDefault();
  toDoList.forEach(function (item, i) {
    if (item.todo == event.target.innerHTML) {
      if (event.ctrlKey) {
        //если зажат Ctrl
        toDoList.splice(i, 1); //удаляем 1 элем c позиции i
      } else {
        item.important != item.important;
      } // иначе инвертируем важно/неваж
      displayMessages();
      localStorage.setItem("todo", JSON.stringify(toDoList));
    }
  });
});
